<template>
  <md-input
      v-model="modelValue"
      v-on="$listeners"
      @keypress="onKeypress"
      @blur="onBlur"
      @paste.prevent
  />
</template>

<script>
// TODO: Компонент некорректно работает при использовании с v-model.number
// (при value type = Number) - это надо поправить

export default {
  name: "NewPriceWings",
  props: {
    value: {
      type: String | Number,
      default: undefined,
    },
    isNegativeAllowed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onKeypress($event) {
      if (/[^-.\d]/g.test($event.key)) {
        $event.preventDefault();
      } else if ($event.key === ".") {
        if (!this.value || this.value.includes(".")) {
          $event.preventDefault();
        }
      } else if ($event.key === "-" && this.isNegativeAllowed) {
        if (this.value || this.value.includes("-")) {
          $event.preventDefault();
        }
      }
    },
    onBlur($event) {
      this.modelValue = (
          $event.target.value && $event.target.value !== "-"
              ? parseFloat($event.target.value).toFixed(4)
              : undefined
      );
    },
  },
};
</script>
